import React from "react";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

import './styles.css';

const Cobertura = () => {
  return (
    <>
      <Card className="text-center">
        <Card.Header><div className="opcoes">Cobertura do sinal</div></Card.Header>
        <Card.Body>
          <Card.Title>Interferências e Zonas Mortas: </Card.Title>
          <Card.Text>
            <div className="opcoes">
              - Equipamentos básicos e antigos frequentemente falham em fornecer cobertura adequada,
              especialmente em ambientes complexos ou de grande porte.<br />
            </div>
            <div className="opcoes">
              - Obstáculos físicos e ambientais, como paredes de concreto, móveis grandes, superfícies metálicas,
              vidros tratados, e eletrodomésticos, linhas de transmissão que causam interferências eletromagnéticas.
            </div>
          </Card.Text>
          {/* <Button variant="primary">Go somewhere</Button> */}
        </Card.Body>
        <Card.Footer className="text-muted"><div className="opcoes">
          Outro problema bastante comum é a proximidade de roteadores operando no mesmo canal,
          o que causa interferências e degrada o desempenho da rede Wi-Fi.</div>
        </Card.Footer>
      </Card>
    </>
  )
}
export default Cobertura;